/** Console languages: the same set as icryptonow.com. Flags live in src/assets/flags/<code>.svg (MIT flag-icons). */
import { flagImg } from "../assets/images.ts";

export const LOCALES = [
  { code: "en", label: "English", html: "en" },
  { code: "zh", label: "简体中文", html: "zh-CN" },
  { code: "zh-hant", label: "繁體中文", html: "zh-Hant" },
  { code: "th", label: "ไทย", html: "th" },
  { code: "vi", label: "Tiếng Việt", html: "vi" },
  { code: "id", label: "Bahasa Indonesia", html: "id" },
  { code: "hi", label: "हिन्दी", html: "hi" },
  { code: "ne", label: "नेपाली", html: "ne" },
  { code: "bn", label: "বাংলা", html: "bn" },
  { code: "ur", label: "اردو", html: "ur", rtl: true },
] as const;

export type Locale = (typeof LOCALES)[number]["code"];
export type LocaleInfo = { code: Locale; label: string; html: string; rtl?: boolean };

export const isLocale = (s: string | null | undefined): s is Locale => !!s && LOCALES.some((l) => l.code === s);
export const localeInfo = (code: Locale): LocaleInfo => LOCALES.find((l) => l.code === code) as LocaleInfo;
export const flagSrc = (code: Locale) => flagImg(code);

/** Best match for the browser's languages (zh-TW/HK/MO → Traditional), else English. */
export function browserLocale(): Locale {
  for (const raw of navigator.languages ?? [navigator.language]) {
    const tag = raw.toLowerCase();
    if (tag.startsWith("zh")) return /-(tw|hk|mo|hant)/.test(tag) ? "zh-hant" : "zh";
    const base = tag.split("-")[0];
    if (isLocale(base)) return base;
  }
  return "en";
}
